import { required } from "vuelidate/lib/validators"; 
const StrIyilestirmeTur = {
  data() {
    return {
      StrIyilestirmeTurData: {
        Tur: null,
        Kod: null,
      },
      FormDataType: { 
        Tur: { FieldName: "Tur", Field: "textarea", FieldTitle: "Tür", FieldType: "text" },
        Kod: { FieldName: "Kod", Field: "textarea", FieldTitle: "Kod", FieldType: "text" },  
      }, 
    }
  },
  validations: {
    FormData: {
      Tur: { required },
      Kod: { required }, 
    },
    Filter:{  
    }
  },
 
}
export default StrIyilestirmeTur